import css from "./index.module.css";
import { nodeIconPaths } from "../../assets/missionIcons";

/**
 * missionprequisite 
 * @param {Number} missionName as the mission number
 * @returns a mission as a hexagon with a styling according to the copletion state of the mission
 */
const MissionPrequisiteIcon = ({missionName, completed, unlocked}) => {
  let state = css.locked;
  if ( completed) {
    state = css.completed;
  } else if (unlocked) {
    state = css.unlocked;
  }
  return (
    <div className={completed ? css.completed : css.uncompleted}>
      <svg className={css.svg}>
        <path d="M0 25.980762113533157L15 0L45 0L60 25.980762113533157L45 51.96152422706631L15 51.96152422706631Z" className={state}></path>
          <svg className={css.svg}>
            <path d={nodeIconPaths[missionName]} className={css.icon}/>
          </svg>
        </svg>
    </div>
  )
}

export default MissionPrequisiteIcon;